import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Loader from 'kepler/lib/components/Loader';
import _find from 'lodash/find';
import AccordionTopicGroup from '../components/AccordionTopicGroup';
import ErrorPanel from '../components/ErrorPanel';
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';
import Breadcrumb from '../containers/Breadcrumb';
import { TOPIC, BREADCRUMB_ITEM } from '../constants/PropTypesShapes';
import { trackLink } from '../../lib/analytics-helper';

const exp = Page.getUserExperience();
const label = i18n.message(`smarthelp/contentToggle.content.label.desktop.${exp}`);
const maxbcLength = 3;

const ArticleList = (props) => {
  const { articleList, breadcrumb } = props;

  const getActiveTopic = () => {
    let selectedArticle;
    if (breadcrumb && breadcrumb.length && (breadcrumb.length === maxbcLength || Page.isMobileLayout())) {
      selectedArticle = _find(articleList.articleList, article => (breadcrumb[breadcrumb.length - 1].id === article.id));
    }
    return selectedArticle;
  };
  const renderArticleList = () => {
    if (!articleList.articleList) {
      return null;
    }
    const options = { name: 'home' };
    Page.setCanonicalTag(options);
    const topics = articleList;
    return <AccordionTopicGroup topics={topics} activeTopic={getActiveTopic()} />;
  };

  const renderContents = () => {
    if (articleList.isLoading) {
      return <Loader size="lg" show type="fixed" />;
    } else if (articleList.error) {
      let topicId;
      const topics = window.location.href.split('/');
      if (topics) {
        topicId = topics.pop();
      }
      trackLink({ id: 'topicPage', link: `smarthelp-error-topics|${topicId}` });
      return <ErrorPanel pageName="topicPage" />;
    }
    return renderArticleList();
  };

  const getBreadcrumbItems = () => (
    !articleList.error ? [{
      path: '/home',
      title: label,
    }] : []
  );
  Page.setDocumentTitle(articleList.articleTitle);
  return (
    <div className="topic-articlelist-container">
      <Breadcrumb items={getBreadcrumbItems()} />
      <h1 className="topic-title">{articleList.articleTitle}</h1>
      <div className="contents">
        { renderContents() }
      </div>
    </div>
  );
};


function mapStateToProps(state) {
  return {
    articleList: state.articleList,
    breadcrumb: state.breadcrumb.items,
  };
}

ArticleList.propTypes = {
  articleList: PropTypes.shape({
    isLoading: PropTypes.bool.isRequired,
    error: PropTypes.bool,
    articleList: PropTypes.arrayOf(PropTypes.shape(TOPIC)),
  }).isRequired,
  breadcrumb: PropTypes.arrayOf(PropTypes.shape(BREADCRUMB_ITEM)),
};

ArticleList.defaultProps = {
  breadcrumb: [],
};

export default connect(mapStateToProps)(ArticleList);
